import createItemFetcher from "../helpers/item";
export const getConfigurationName = (config) => config.configurationName;
function computeItemId() {
    return `oidcConfiguration`;
}
const computeConfigurationUrl = () => `/api/v1/authconfig`;
export const oidcConfiguration = createItemFetcher(computeConfigurationUrl, "OIDC_CONFIGURATION", computeItemId);
//# sourceMappingURL=index.js.map